import { FC } from 'react'
import s from './SidebarSticky.module.sass'

interface Props {
  children: React.ReactNode
}

const SidebarSticky: FC<Props> = ({ children }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.sticky}>{children}</div>
    </div>
  )
}

export default SidebarSticky
